import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  GenericConfig, RestUrlsConfig }  from '@signature-it/ngx-generic/config';
import { Observable , throwError } from 'rxjs';
import {tap} from 'rxjs/operators';
import {ProductFullSolrDTO} from "@signature-it/ngx-catalogue/models";

@Injectable({
  providedIn: 'root'
})
export class ProductPageService_Generic {
    protected getExistingImagesUrl = `${this.restUrlsConf.appURL}/public/product/get_existing_images.json`;
    protected sendFeedbackUrl = `${this.restUrlsConf.appURL}/public/product/send_feedback`;
    private _mainProduct: ProductFullSolrDTO;

    constructor(protected restUrlsConf: RestUrlsConfig,
                protected http: HttpClient) {
    }

    set mainProduct(product)  {
        this._mainProduct = product;
    }

    get mainProduct() {
        return this._mainProduct;
    }

    getExistingImage(data): Observable<any> {
        return this.http.post(this.getExistingImagesUrl, JSON.stringify(data))
            .pipe(tap((res) => res, (error: any) => throwError(error)));
    }

    getQuicklinks(productId:number) {
        return this.http.get(`${this.restUrlsConf.appURL}/public/product/${productId}/kit/quicklinks.json`)
            .pipe(tap((res) => res, (error: any) => throwError(error)));
    }

    getAllQuicklinks(productId) {
        return this.http.get(`${this.restUrlsConf.appURL}/public/product/${productId}/quicklinks.json`)
            .pipe(tap((res) => res, (error: any) => throwError(error)));
    }

    getProductMediaAssets(productId: number) {
        return this.http.get(`${this.restUrlsConf.appURL}/public/product/${productId}/mediaAssets.json`)
            .pipe(tap((res) => res, (error: any) => throwError(error)));
    }

    getMediaAssetsByParams(params: any) {
        return this.http.post(`${this.restUrlsConf.appURL}/public/product/mediaAssets.json`, JSON.stringify(params))
            .pipe(tap((res) => res, (error: any) => throwError(error)));
    }

    // getStock(productsCode: any) {
    //     return this.http.get(`${this.restUrlsConf.appURL}/public/product/${productsCode}/stock.json`)
    //         .pipe(tap((res) => res, (error: any) => throwError(error)));
    // }

    sendFeedback(data): Observable<any> {
        return this.http.post(this.sendFeedbackUrl, JSON.stringify(data))
            .pipe(tap((res) => res, (error: any) => throwError(error)));
    }

    getKitContextFields() {
        return [
            {
                name: 'product_code',
                solr_field: 'product_code_s',
                order: '-3',
                alias: 'Product Code',
            },
            {
                name: 'product_name',
                solr_field: 'product_name_s',
                order: '-2',
                alias: 'Product Name',
            },
            {
                name: 'product_pic',
                solr_field: 'product_pic_s',
                order: '-4',
                alias: 'Product Pic',
            },
            {
                name: 'quantity',
                solr_field: 'quantity',
                order: '-1',
                alias: 'Quantity',
                data: 'quicklinks'
            }

        ];
    }

}
